/** IDs statut ERP (existants + migration add_statuts_bon_reception_pv_ecart.sql). */
export const WORKFLOW_STATUT_IDS: Record<string, number> = {
    Brouillon: 1,
    Accepté: 3,
    Payé: 5,
    Annulé: 6,
    Négociation: 8,
    Crée: 9,
    Créé: 9,
    Valide: 10,
    Livré: 11,
    'Non payé': 12,
    'Non Payé': 12,
    Fermé: 13,
    Reçu: 14,
    'Partiellement payé': 15,
    'En cours': 16,
    Transféré: 17,
    Utilisé: 18,
    'Non utilisé': 19,
    'Partiellement utilisé': 20,
    'À réceptionner': 21,
    'En contrôle': 22,
    Réceptionné: 23,
    'Réception partielle': 24,
    'Avec écart': 25,
    Clôturé: 26,
    Soumis: 27,
    'En traitement': 28,
    Validé: 29,
    Rejeté: 30,
};

export const BON_RECEPTION_STATUS_LABELS = [
    'Brouillon',
    'À réceptionner',
    'En contrôle',
    'Réceptionné',
    'Réception partielle',
    'Avec écart',
    'Clôturé',
    'Annulé',
] as const;

export const PV_ECART_STATUS_LABELS = [
    'Brouillon',
    'Soumis',
    'En traitement',
    'Validé',
    'Rejeté',
    'Clôturé',
] as const;

export interface DocumentStatusTabDef {
    path: string;
    label: string;
    status: string;
}

export const BON_RECEPTION_STATUS_TABS: DocumentStatusTabDef[] = [
    { path: 'tous', label: 'Tous', status: 'Tous' },
    { path: 'brouillon', label: 'Brouillon', status: 'Brouillon' },
    { path: 'a-receptionner', label: 'À réceptionner', status: 'À réceptionner' },
    { path: 'en-controle', label: 'En contrôle', status: 'En contrôle' },
    { path: 'receptionne', label: 'Réceptionné', status: 'Réceptionné' },
    { path: 'reception-partielle', label: 'Réception partielle', status: 'Réception partielle' },
    { path: 'avec-ecart', label: 'Avec écart', status: 'Avec écart' },
    { path: 'cloture', label: 'Clôturé', status: 'Clôturé' },
    { path: 'annule', label: 'Annulé', status: 'Annulé' },
    /** Rétrocompatibilité URL */
    { path: 'cree', label: 'À réceptionner', status: 'À réceptionner' },
    { path: 'recu', label: 'Réceptionné', status: 'Réceptionné' },
];

export const PV_ECART_STATUS_TABS: DocumentStatusTabDef[] = [
    { path: 'tous', label: 'Tous', status: 'Tous' },
    { path: 'brouillon', label: 'Brouillon', status: 'Brouillon' },
    { path: 'soumis', label: 'Soumis', status: 'Soumis' },
    { path: 'valide', label: 'Validé', status: 'Validé' },
    { path: 'cloture', label: 'Clôturé', status: 'Clôturé' },
];

export const BON_TRANSFERT_STATUS_LABELS = [
    'Brouillon',
    'Crée',
    'En cours',
    'Transféré',
    'Annulé',
] as const;

export const BON_TRANSFERT_STATUS_TABS: DocumentStatusTabDef[] = [
    { path: 'tous', label: 'Tous', status: 'Tous' },
    { path: 'brouillon', label: 'Brouillon', status: 'Brouillon' },
    { path: 'cree', label: 'Crée', status: 'Crée' },
    { path: 'en-cours', label: 'En cours', status: 'En cours' },
    { path: 'transfere', label: 'Transféré', status: 'Transféré' },
    { path: 'annule', label: 'Annulé', status: 'Annulé' },
];

/** Bon de réception uniquement (via resolveWorkflowListStatusLabel / achat.service). */
const LEGACY_STATUT_DISPLAY: Record<string, string> = {
    Crée: 'À réceptionner',
    Créé: 'À réceptionner',
    Reçu: 'Réceptionné',
};

/** Filtre liste : un onglet peut matcher plusieurs statut_id (legacy). */
const FILTER_IDS_BY_CANONICAL: Record<string, number[]> = {
    'À réceptionner': [21, 9],
    Réceptionné: [23, 14],
    'En contrôle': [22],
    'Réception partielle': [24],
    'Avec écart': [25],
    Clôturé: [26, 13],
    Soumis: [27],
    'En traitement': [28],
    Validé: [29, 10],
    Rejeté: [30],
    Brouillon: [1],
    Annulé: [6],
    Crée: [9],
    'En cours': [16],
    Transféré: [17],
};

export function mergeWorkflowStatutIdMap(
    base: Record<string, number> = {}
): Record<string, number> {
    return { ...base, ...WORKFLOW_STATUT_IDS };
}

/** Fusionne les titres réels de `statut_documents` (priorité API sur les ids en dur). */
export function mergeStatutDocumentsFromApiIntoIdMap(
    base: Record<string, number>,
    statuts: Array<{ id?: number; titre?: string | null }> | null | undefined
): Record<string, number> {
    const out = { ...base };
    if (!Array.isArray(statuts)) {
        return out;
    }
    for (const row of statuts) {
        const titre = String(row?.titre ?? '').trim();
        const id = Number(row?.id);
        if (!titre || !Number.isFinite(id) || id <= 0) {
            continue;
        }
        out[titre] = id;
        const key = normalizeStatutKeyForCompare(titre);
        if (key === 'EN TRAITEMENT') {
            out['En traitement'] = id;
        } else if (key === 'SOUMIS') {
            out['Soumis'] = id;
        } else if (key === 'VALIDE') {
            out['Validé'] = id;
            out['Valide'] = id;
        } else if (key === 'REJETE') {
            out['Rejeté'] = id;
        } else if (key === 'CLOTURE') {
            out['Clôturé'] = id;
        }
    }
    return out;
}

export function extractStatutDocumentsListFromApiResponse(res: unknown): Array<{ id?: number; titre?: string }> {
    if (res == null || typeof res !== 'object') {
        return [];
    }
    const root = res as Record<string, unknown>;
    const data = root['data'];
    if (Array.isArray(data)) {
        return data as Array<{ id?: number; titre?: string }>;
    }
    if (data != null && typeof data === 'object') {
        const statuts = (data as Record<string, unknown>)['statuts'];
        if (Array.isArray(statuts)) {
            return statuts as Array<{ id?: number; titre?: string }>;
        }
    }
    const statutsRoot = root['statuts'];
    if (Array.isArray(statutsRoot)) {
        return statutsRoot as Array<{ id?: number; titre?: string }>;
    }
    return [];
}

export function normalizeWorkflowStatutLabel(raw: string | null | undefined): string {
    const s = String(raw ?? '').trim();
    if (!s) {
        return s;
    }
    return LEGACY_STATUT_DISPLAY[s] ?? s;
}

export function getWorkflowStatutId(label: string): number | null {
    const canonical = normalizeWorkflowStatutLabel(label);
    const id = WORKFLOW_STATUT_IDS[canonical] ?? WORKFLOW_STATUT_IDS[label];
    return id != null ? id : null;
}

/**
 * PV d'écart : libellé par statut_id (21 = Soumis en prod LC, pas « À réceptionner » BR).
 */
export function getPvEcartDisplayLabelByStatutId(statutId: number): string | null {
    const id = Number(statutId);
    if (!Number.isFinite(id)) {
        return null;
    }
    const byId: Record<number, string> = {
        1: 'Brouillon',
        6: 'Annulé',
        9: 'Soumis',
        13: 'Clôturé',
        21: 'Soumis',
        26: 'Clôturé',
        27: 'Soumis',
        28: 'En traitement',
        29: 'Validé',
        30: 'Rejeté',
    };
    return byId[id] ?? null;
}

/** Libellé affiché pour un statut_id workflow (21–30) ou legacy BR (9, 14). */
export function getWorkflowDisplayLabelByStatutId(statutId: number): string | null {
    const id = Number(statutId);
    if (!Number.isFinite(id)) {
        return null;
    }
    const byId: Record<number, string> = {
        9: 'À réceptionner',
        14: 'Réceptionné',
        21: 'À réceptionner',
        22: 'En contrôle',
        23: 'Réceptionné',
        24: 'Réception partielle',
        25: 'Avec écart',
        26: 'Clôturé',
        27: 'Soumis',
        28: 'En traitement',
        29: 'Validé',
        30: 'Rejeté',
    };
    return byId[id] ?? null;
}

/** statut_id API pour BR si les IDs 21+ ne sont pas encore en base. */
export function getBonReceptionLegacyStatutId(label: string): number | null {
    const canonical = normalizeWorkflowStatutLabel(label);
    const legacy: Record<string, number> = {
        'À réceptionner': 9,
        Réceptionné: 14,
        Reçu: 14,
        Crée: 9,
        Créé: 9,
    };
    return legacy[canonical] ?? legacy[label] ?? null;
}

export function getWorkflowStatutFilterIds(label: string): number[] {
    const canonical = normalizeWorkflowStatutLabel(label);
    const fromMap = FILTER_IDS_BY_CANONICAL[canonical];
    if (fromMap?.length) {
        return fromMap;
    }
    const single = getWorkflowStatutId(canonical);
    return single != null ? [single] : [];
}

export function normalizeStatutKeyForCompare(value: unknown): string {
    return String(value ?? '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toUpperCase();
}

export function isBonReceptionReceptionStockStatut(label: string): boolean {
    const k = normalizeStatutKeyForCompare(normalizeWorkflowStatutLabel(label));
    return (
        k === 'RECU' ||
        k === 'RECEPTIONNE' ||
        k === 'RECEPTION PARTIELLE'
    );
}

export function bonReceptionPathToStatusLabel(path: string): string {
    const p = (path || '').toLowerCase();
    const tab = BON_RECEPTION_STATUS_TABS.find((t) => t.path === p);
    return tab?.status ?? 'Tous';
}

export function pvEcartPathToStatusLabel(path: string): string {
    const p = (path || '').toLowerCase();
    const tab = PV_ECART_STATUS_TABS.find((t) => t.path === p);
    return tab?.status ?? 'Tous';
}

export function bonTransfertPathToStatusLabel(path: string): string {
    const p = (path || '').toLowerCase();
    const tab = BON_TRANSFERT_STATUS_TABS.find((t) => t.path === p);
    return tab?.status ?? 'Tous';
}

/** Libellé affiché pour un bon de transfert ERP (statut_id). */
export function getBonTransfertDisplayLabelByStatutId(statutId: number): string | null {
    const id = Number(statutId);
    if (!Number.isFinite(id)) {
        return null;
    }
    const byId: Record<number, string> = {
        1: 'Brouillon',
        6: 'Annulé',
        9: 'Crée',
        16: 'En cours',
        17: 'Transféré',
    };
    return byId[id] ?? null;
}

/** Clé sans accent (minuscules) → libellé canonique PV d'écart. */
const BON_TRANSFERT_STATUS_BY_COMPARE_KEY: Record<string, string> = {
    tous: 'Tous',
    brouillon: 'Brouillon',
    cree: 'Crée',
    'en cours': 'En cours',
    transfere: 'Transféré',
    annule: 'Annulé',
};

const PV_ECART_STATUS_BY_COMPARE_KEY: Record<string, string> = {
    tous: 'Tous',
    brouillon: 'Brouillon',
    soumis: 'Soumis',
    'en traitement': 'En traitement',
    valide: 'Validé',
    rejete: 'Rejeté',
    cloture: 'Clôturé',
};

/**
 * Libellé de statut pour listes / onglets (évite Valide ≠ Validé après strip accents).
 */
export function resolveWorkflowListStatusLabel(
    raw: string,
    documentType?: string | null
): string {
    const repaired = String(raw ?? '').trim();
    if (!repaired) {
        return repaired;
    }
    if (documentType === 'bon-reception') {
        const canonical = normalizeWorkflowStatutLabel(repaired) || repaired;
        if (canonical === 'À réceptionner') {
            return 'En attente de réception';
        }
    }
    const key = normalizeStatutKeyForCompare(repaired).toLowerCase();
    if (documentType === 'pv-ecart') {
        const canonicalBr = normalizeWorkflowStatutLabel(repaired);
        if (
            canonicalBr === 'À réceptionner' ||
            canonicalBr === 'Crée' ||
            canonicalBr === 'Créé'
        ) {
            return 'Soumis';
        }
        if (key === 'a receptionner' || key === 'cree') {
            return 'Soumis';
        }
        const pv = PV_ECART_STATUS_BY_COMPARE_KEY[key];
        if (pv) {
            return pv;
        }
    }
    if (documentType === 'bon-transfert') {
        const bt = BON_TRANSFERT_STATUS_BY_COMPARE_KEY[key];
        if (bt) {
            return bt;
        }
    }
    return normalizeWorkflowStatutLabel(repaired) || repaired;
}

/** Transitions autorisées (clés normalisées sans accents, minuscules). */
export const BON_RECEPTION_STATUS_TRANSITIONS: Record<string, string[]> = {
    brouillon: ['À réceptionner', 'Annulé'],
    'a receptionner': ['En contrôle', 'Annulé'],
    'en controle': ['Réceptionné', 'Réception partielle', 'Avec écart', 'Annulé'],
    receptionne: ['Clôturé', 'Annulé'],
    'reception partielle': ['Clôturé', 'Annulé'],
    'avec ecart': ['Clôturé', 'Annulé'],
    cloture: [],
    annule: [],
};

export const PV_ECART_STATUS_TRANSITIONS: Record<string, string[]> = {
    brouillon: ['Soumis', 'Annulé'],
    soumis: ['Validé', 'Annulé'],
    /** Legacy — documents déjà « En traitement » en base. */
    'en traitement': ['Validé', 'Annulé'],
    valide: ['Clôturé'],
    /** Legacy — plus d’onglet dédié. */
    rejete: ['Validé', 'Clôturé'],
    cloture: [],
};
